import { Component, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { INGREDIENT_CATEGORIES_ICONS_A, INGREDIENT_CATEGORIES_ICONS_B } from 'src/app/class/data';
import { BlockPeriodClass } from 'src/app/class/meal-plan/block-period.class';
import { MealTimeClass } from 'src/app/class/meal-plan/meal-time.class';
import { IIngredientCategory } from 'src/app/interfaces/database/database.interface';
import { IFoodGroupIngredient } from 'src/app/models/food-group';
import { IngredientState } from 'src/app/models/ingredient';



@Component({
  selector: 'app-category-requirements',
  templateUrl: './category-requirements.component.html',
  styleUrls: ['./category-requirements.component.scss']
})
export class CategoryRequirementsComponent implements OnDestroy {
  @Input() mealTime: MealTimeClass;

  mapCategoryPortions = {};
  mapCategoryIsRequired = {};
  extraIngredients = false;
  categories!: IIngredientCategory[];

  iconsRoute = './../../../assets/images/icons/ingredients_group/';
  iconsName = INGREDIENT_CATEGORIES_ICONS_B;

  // iconsNameA = INGREDIENT_CATEGORIES_ICONS_A;
  // iconsNameB = INGREDIENT_CATEGORIES_ICONS_B;

  private destroy$ = new Subject<void>();

  constructor(private store: Store) { }

  ngOnChanges(changes: SimpleChanges): void { // Usar ngOnChanges para reaccionar a cambios en blockPeriod
    if (changes.blockPeriod) {
      this.buildMapCategoryPortions();
    }
  }

  ngOnInit(): void {
    this.store.select(IngredientState.getIngredientCategories).pipe(
      takeUntil(this.destroy$)
    ).subscribe(categories => this.categories = categories);

    this.buildMapCategoryPortions();
  }

  private buildMapCategoryPortions(): void {
    if (!this.mealTime || !this.categories) return;

    this.extraIngredients = false;
    this.mapCategoryPortions = {};
    this.mapCategoryIsRequired = {};

    this.mealTime.blockPeriods.forEach((blockPeriod: BlockPeriodClass) => {
      blockPeriod.ingredients.forEach((ingredient: Partial<IFoodGroupIngredient>) => {
        if (!ingredient.category) return; // Seguridad: Verificar que la categoría exista
        this.mapCategoryPortions[ingredient.category._id] = this.mapCategoryPortions[ingredient.category._id] || 0;
        this.mapCategoryPortions[ingredient.category._id] += ingredient.smae.portion;
        if (this.mealTime.metadata.nutrientTable && this.mealTime.metadata.nutrientTable[ingredient.category._id]) {
          this.mapCategoryIsRequired[ingredient.category._id] = true;
          this.extraIngredients = true;
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
